export default "__VITE_ASSET__Ciw_Vepp__"